/**
 * Module: Email Form
 * Parent Block(s):
 * - Newsletter
 */

/**
 * DWT dependencies
 */


import { useEffect } from '@wordpress/element';
import { getParentBlockAttrs } from '../utils/block-utils';

/**
 * DWT dependencies
 */

import {
  InspectorControls,
  useBlockProps,
  useInnerBlocksProps
} from '@wordpress/block-editor';

import { PanelBody, RadioControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const Edit = ({ attributes, setAttributes, context, clientId }) => {
  const {
    labelBackgroundColor,
    formStyle,
    errorId
  } = attributes;

  useEffect( () => {
    if ( !errorId ) {
      setAttributes({ errorId: `error-message-${clientId}` });
    }
  }, [ errorId ] );

  const onChangeFormStyle = ( newFormStyle ) => {
    setAttributes({ formStyle: newFormStyle });
  };

  const blockProps = useBlockProps({
    className: 'block__email-form'
  });

  const { children, ...innerBlocksProps } = useInnerBlocksProps(
    { className: 'email-form__button' },
    {
      allowedBlocks: [],
      template: [ [ 'dwt/button' ] ],
      templateLock: 'all',
      renderAppender: false
    }
  );

  const hasContext = Object.keys( context ).length > 0;

  if ( hasContext ) {
    let backgroundColor = null;
    for ( const [ value ] of Object.entries( context ) ) {
      backgroundColor = value || '#ffffff';
      setAttributes({ labelBackgroundColor: backgroundColor });
    }
  }

  const attrs = getParentBlockAttrs( clientId );
  setAttributes({ newsletterAttrs: attrs });

  return (
    <>
      <InspectorControls>
        <PanelBody title={ __( 'Form Style', 'dwt-custom-theme' ) }>
          <RadioControl
            selected={formStyle}
            options={[
              { label: 'Outline', value: 'is-outline' },
              { label: 'Underline', value: 'is-underline' }
            ]}
            onChange={onChangeFormStyle}
            __nextHasNoMarginBottom
          />
        </PanelBody>
      </InspectorControls>

      <div { ...blockProps }>
        <div className='email-form__form'>
          <div className='email-form__label'>
            <span
              className='email-form__label-text'
              style={{ backgroundColor: labelBackgroundColor }}
            >
              { __( 'Email Address', 'dwt-custom-theme' ) }
            </span>
          </div>
          <div className={`email-form__input ${formStyle}`}>
            divisions@penguinrandomhouse.com
          </div>

          {/* Block button */}
          <div { ...innerBlocksProps }>
            { children }
          </div>

        </div>
      </div>
    </>
  );
};

export default Edit;
